import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useCluster } from '@cast/shared-cluster-context-data-access';

const NODE_TEMPLATES_REPORT_QUERY_KEY = 'node-templates-report';

const getNodeTemplatesReportQueryKey = (clusterId: string) =>
  [NODE_TEMPLATES_REPORT_QUERY_KEY, clusterId] as const;

const getNodeTemplatesReportQueryOptions = (clusterId: string) =>
  queryOptions({
    queryKey: getNodeTemplatesReportQueryKey(clusterId),
    queryFn: async () => {
      const response = await apiClient.costReport.getClusterNodeTemplatesReport(
        {
          clusterId,
        }
      );
      return response.data;
    },
    enabled: !!clusterId,
  });

export const useNodeTemplatesReportQuery = () => {
  const { cluster } = useCluster();

  return useQuery(getNodeTemplatesReportQueryOptions(cluster.id));
};
